import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW4502Model } from './kymw4502.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { ExecuteFeatureCopyService } from './api-services/executeFeatureCopy.service';
import { GetMediumListForFeatureCopyService } from './api-services/getMediumListForFeatureCopy.service';
import { GetMediumListService } from '../../../commons/kymw02/api-services/get-medium-list.service';
import { WjFlexGrid } from '@grapecity/wijmo.angular2.grid';
import { OrderCodeTextInputComponent } from 'src/app/commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';

/**
 * 特集コピー画面を管理するクラス
 *
 * @export KYMW4502Component
 * @class KYMW4502Component
 */
@Component({
  selector: 'app-kymw4502',
  templateUrl: 'kymw4502.component.html',
  styleUrls: ['kymw4502.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW4502Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('txti_CatalogId', { static: true }) txti_CatalogId: ElementRef;
  @ViewChild('txti_OrderCode', { static: true }) txti_OrderCode: OrderCodeTextInputComponent;

  public kymw4502Model: KYMW4502Model = new KYMW4502Model();

  @ViewChild('dtg_MediumTypeList', { static: true }) dtg_MediumTypeList: WjFlexGrid;

  // ウィンドウを閉じる際の処理
  public closeFunction: Function;

  /**
   * Creates an instance of KYMW4502Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @param {OutputPhotoChargeListFileService} outputPhotoChargeListFileService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW4502Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    public executeFeatureCopyService: ExecuteFeatureCopyService,
    public getMediumListForFeatureCopyService: GetMediumListForFeatureCopyService,
    public getMediumListService: GetMediumListService,
    public kymw00Model: KYMW00Model,
    public elementRef: ElementRef,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   * @memberof KYMW4502Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW4502';

    this.dtg_MediumTypeList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_MediumTypeList.hitTest(e);
      if (0 <= ht.row && (!ht.target.className.includes('wj-header') && !ht.target.className.includes('ng-valid'))) {
        if (ht.col === 0) {
          document.getElementById(`selected_${ht.row}`)?.click();
        }
      }
    });
  }

  /**
   * 企画回の値を変更したとき
   */
  eventBlurHandler_CatalogId() {
    // 企画回が8桁未満の場合
    if (this.kymw4502Model.copiedCatalogId.length < 8) {
      // 共通コンポーネントの処理でコピー元受注コードはクリアされる
      // 媒体一覧の表示内容をクリアする。
      this.kymw4502Model.mediumTypeList = [];
      return;
    }
  }

  /**
   * 受注コードの値を変更したとき
   */
  eventBlurHandler_OrderCode() {
    // 受注コードが7桁未満の場合
    if (this.kymw4502Model.copiedOrderCode.length < 7) {
      // 共通コンポーネントの処理でコピー元企画回はクリアされる
      // 媒体一覧の表示内容をクリアする。
      this.kymw4502Model.mediumTypeList = [];
      return;
    }
  }

  /**
   * 表示ボタン押下時のイベント
   */
  public eventClickHandler_Display(): void {
    // 入力必須チェック処理
    if (this.kymw4502Model.copiedCatalogId === '') {
      this.dialogService.openAlertGetMessage('W0001', ['コピー元企画回'], null);
      return;
    }
    // 桁数・属性チェック
    if (this.kymw4502Model.copiedCatalogId.length < 8) {
      this.dialogService.openAlertGetMessage('E0113', ['コピー元企画回'], null);
      return;
    }
    // コピー元企画回の特集情報の取得する
    const request = {
      copyToOrderCode: this.kymw4502Model.orderCode,
      copyFromOrderCode: this.kymw4502Model.copiedOrderCode,
    };
    this.getMediumListForFeatureCopyService.execute(request, this.kymw4502Model);

    // 5. コピー元企画回の特集情報のない媒体はグレー表示し、選択は非活性にする。
    this.dtg_MediumTypeList.loadedRows.addHandler(_ => {
      const grid = this.dtg_MediumTypeList;
      for (let i = 0; i < grid.rows.length; i++) {
        if (!grid.rows[i].dataItem.copiable) {
          grid.rows[i].cssClass = 'lbl_gray';
        }
      }
    });
  }

  /**
   * 決定ボタン押下時のイベント
   */
  public eventClickHandler_Decide(e: Event): void {
    // 入力必須チェック処理
    if (this.kymw4502Model.copiedCatalogId === '') {
      this.dialogService.openAlertGetMessage('W0001', ['コピー元企画回'], null);
      return;
    }
    // 桁数・属性チェック
    if (this.kymw4502Model.copiedCatalogId.length < 8) {
      this.dialogService.openAlertGetMessage('E0113', ['コピー元企画回'], null);
      return;
    }
    // 選択がTRUEである媒体情報が１つもないとき														
    if (this.kymw4502Model.mediumTypeList.filter(_ => _.checked).length === 0) {
      this.dialogService.openAlertGetMessage('W0001', ['媒体の選択'], null);
      return;
    }
    // コピー実行
    this.executeFeatureCopyService.execute(this.kymw4502Model);
  }
}
